import React from 'react'
import {createBrowserRouter } from 'react-router-dom'
import Home from '../views/home'
import Introduction from "../views/Introduction";
import UpdateLog from '../views/UpdateLog'
import GettingStarted from "../views/GettingStarted";
import McLineChart from "../views/McLineChart";
import McBarChart from "../views/McBarChart";
import McHorBarChart from "../views/McHorBarChart";
import McPieChart from "../views/McPieChart";
import McPointChart from "../views/McPointChart";
import McRadarChart from "../views/McRadarChart";
import McLineBarChart from "../views/McLineBarChart";
import McGaugeChart from "../views/McGaugeChart";
import CommonConfig from "../views/CommonConfig";
import EcologicalCase from "../views/EcologicalCase";
import ProjectTemplate from "../views/ProjectTemplate";
import FAQ from "../views/FAQ";
const router = createBrowserRouter ([
    {
        path: '*',
        element: <Home />
    },
    {
        path: '/Introduction',
        element: <Introduction />
    },
    {
        path: '/GettingStarted',
        element: <GettingStarted />
    },
    {
        path: '/CommonConfig',
        element: <CommonConfig />
    },
    {
        path: '/McLineChart',
        element: <McLineChart />
    },
    {
        path: '/McBarChart',
        element: <McBarChart />
    },
    {
        path: '/McLineBarChart',
        element: <McLineBarChart />
    },
    {
        path: '/McHorBarChart',
        element: <McHorBarChart />
    },
    {
        path: '/McPieChart',
        element: <McPieChart />
    },
    {
        path: '/McPointChart',
        element: <McPointChart />
    },
    {
        path: '/EcologicalCase',
        element: <EcologicalCase />
    },
    {
        path: '/McRadarChart',
        element: <McRadarChart />
    },
    {
        path: '/McGaugeChart',
        element: <McGaugeChart />
    },
    {
        path: '/updateLog',
        element: <UpdateLog />
    },
    {
        path: '/faq',
        element: <FAQ />
    },
    {
        path: '/ProjectTemplate',
        element: <ProjectTemplate />
    }
])

export default router
